/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Surcharge/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Surcharge({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AcknowledgePlatformFee/Content/IsAcknowledged/AcknowledgementText/Surcharge"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let providerAccountCardFeePercentValueData = fromData.useDataFormat({ viewPath,
context: 'provider_account',
path: 'card_fee_percent',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<div
  data-testid="Surcharge.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z154VlA': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCheckboxText
  viewPath={`${viewPath}/TysiaCheckboxText`}
 data="provider_account.card_fee_percent"
 format="helpers.js getText"
 text={providerAccountCardFeePercentValueData}
/>
</div>
{children}
</React.Fragment>)
}